
export enum EnumTipoComercializacao {
  Atacado = 'Atacado',
  Varejo = 'Varejo',
}
